import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Box, Flex, Image, Text, ProgressBar, List, ButtonFilled } from '../../Base';
import { ClassroomDrawer } from '../Components';

// onCloseDrawer prop is passed from <ClassroomDrawer />
const CourseInfoPanelInnerComponent = withTheme(
  ({
    theme,
    courseInfoListItems,
    title,
    progress,
    onCloseDrawer,
    onClickAction1,
    onClickAction2,
    showActionPanel,
  }) => {
    return (
      <Box p={4}>
        <ProgressBar value={progress} label={'Complete'} mb={4} />
        <List
          items={courseInfoListItems}
          renderItem={({ left, right, rightProps }) => {
            return (
              <Flex mb={4} key={left}>
                <Text width={'50%'}>{left || '-'}</Text>
                <Text fontWeight={'bold'} {...rightProps}>
                  {right || '-'}
                </Text>
              </Flex>
            );
          }}
          columns={1}
          childSpacing={'0px'}
          rowSpacing={theme.space[4]}
        />
        {showActionPanel && (
          <Flex justifyContent={'space-between'}>
            <ButtonFilled color={'coolGrey.grey3'} width={1} py={2} mr={3} onClick={onClickAction1}>
              <Image
                width={'60px'}
                mx={'auto'}
                srcSet={
                  '/assets/images/classroom/clearButton-1x.png 1x, /assets/images/classroom/clearButton-2x.png 2x, /assets/images/classroom/clearButton-3x.png 3x,'
                }
                src={'/assets/images/classroom/clearButton-3x.png'}
              />
            </ButtonFilled>

            <ButtonFilled color={'coolGrey.grey3'} py={2} width={1} onClick={onClickAction2}>
              <Image
                width={'60px'}
                mx={'auto'}
                srcSet={
                  '/assets/images/classroom/onlineSolutionButton-1x.png 1x, /assets/images/classroom/onlineSolutionButton-2x.png 2x, /assets/images/classroom/onlineSolutionButton-3x.png 3x,'
                }
                src={'/assets/images/classroom/onlineSolutionButton-3x.png'}
              />
            </ButtonFilled>
          </Flex>
        )}
      </Box>
    );
  }
);

CourseInfoPanelInnerComponent.propTypes = {
  courseInfoListItems: PropTypes.arrayOf(
    PropTypes.shape({
      left: PropTypes.node,
      right: PropTypes.node,
      rightProps: PropTypes.object,
    })
  ),
  title: PropTypes.string,
  progress: PropTypes.number,
  onCloseDrawer: PropTypes.func,
  onClickAction1: PropTypes.func,
  onClickAction2: PropTypes.func,
  showActionPanel: PropTypes.bool,
};

CourseInfoPanelInnerComponent.defaultProps = {
  courseInfoListItems: [],
  showActionPanel: false,
};

const CourseInfoPanel = ({ toggleComponent, drawerProps, title, ...restProps }) => {
  return (
    <ClassroomDrawer drawerProps={drawerProps} title={title} toggleComponent={toggleComponent}>
      <CourseInfoPanelInnerComponent {...restProps} />
    </ClassroomDrawer>
  );
};

CourseInfoPanel.propTypes = {
  ...ClassroomDrawer.propTypes,
  ...CourseInfoPanelInnerComponent.propTypes,
};

export default CourseInfoPanel;
